<template>
  <div
    v-if="!showSkeleton"
    ref="propertyListing"
    data-file="PropertyListingFeatured"
    class="property tw-h-full tw-rounded-[16px] tw-bg-gradient-orange tw-p-[2px]"
    :class="[listing, classList, { shortlist: shortlistedLocal }]"
  >
    <div
      class="max-w-100 position-relative w-100 listing h-100 m-0 tw-rounded-[15px] tw-bg-white tw-shadow-lg hover:tw-shadow-md"
    >
      <div
        v-if="!isShortlistView"
        class="tw-absolute tw-left-0 tw-top-0 tw-z-10 tw-flex tw-items-center tw-justify-center tw-gap-[4px] tw-rounded-[14px_0_16px_0] tw-bg-button-grad tw-px-[16px] tw-py-[8px] tw-text-[12px] tw-font-[800] tw-text-white"
      >
        <img
          :src="cdnAsset('svg/featured-star.svg')"
          alt=""
          aria-hidden="true"
        />
        Featured
      </div>

      <a
        class="property-card-link noSelect focus-visible:tw-rounded-[15px] focus-visible:tw-shadow-md focus-visible:tw-ring-2 focus-visible:tw-ring-[#61B3E5] focus-visible:tw-ring-offset-2"
        :href="property.path"
        data-cy="property-listing"
        data-uh="property-card"
        @click.self.prevent="redirectToPropertyPage"
      >
        <div class="property_img tw-rounded-tl-[15px] tw-rounded-tr-[15px]">
          <div
            v-if="
              (isShortlistView ||
                (enableShortlistInSearch && shortlistActive)) &&
              (!enableShortlistInSearch || shortlistSelectionMode)
            "
            class="tw-absolute tw-z-[5] tw-flex tw-items-center tw-justify-center"
            :class="
              shortlistSelectionMode
                ? 'tw-right-3 tw-top-3 tw-h-[32px] tw-w-[32px]'
                : 'tw-left-0 tw-top-0 tw-h-[56px] tw-w-[56px] tw-rounded-br-[8px] tw-bg-white'
            "
            data-shortlist-selection-control
            @click.stop
          >
            <label
              class="tw-relative tw-flex tw-cursor-pointer tw-items-center tw-p-2"
            >
              <input
                type="checkbox"
                class="tw-peer tw-sr-only"
                :checked="localIsSelected"
                aria-label="Select property"
                @change="onSelectChange"
              />

              <span
                class="tw-aspect-square tw-box-content tw-flex tw-h-[32px] tw-w-[32px] tw-items-center tw-justify-center tw-rounded-[50px] tw-border-2 tw-border-[#E5E7EB] tw-bg-white/60 tw-transition-all tw-duration-150 peer-focus-visible:tw-ring-2 peer-focus-visible:tw-ring-[#61B3E5] peer-focus-visible:tw-ring-offset-2"
                :class="
                  shortlistSelectionMode
                    ? 'peer-checked:tw-border peer-checked:tw-border-[#E5E7EB] peer-checked:tw-bg-white'
                    : 'tw-rounded-[4px] tw-border-[#3B4143] tw-bg-white peer-checked:tw-border-[#00A2E1] peer-checked:tw-bg-[#00A2E1]'
                "
              >
                <svg
                  v-if="shortlistSelectionMode && localIsSelected"
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  class="tw-aspect-square tw-h-[24px] tw-w-[24px] tw-shrink-0"
                >
                  <path
                    data-figma-bg-blur-radius="4"
                    d="M12 0C9.62663 0 7.30655 0.703788 5.33316 2.02236C3.35977 3.34094 1.8217 5.21508 0.913451 7.4078C0.00519941 9.60051 -0.232441 12.0133 0.230582 14.3411C0.693605 16.6689 1.83649 18.807 3.51472 20.4853C5.19295 22.1635 7.33115 23.3064 9.65892 23.7694C11.9867 24.2324 14.3995 23.9948 16.5922 23.0865C18.7849 22.1783 20.6591 20.6402 21.9776 18.6668C23.2962 16.6934 24 14.3734 24 12C23.9966 8.81843 22.7313 5.76814 20.4816 3.51843C18.2319 1.26872 15.1816 0.00335979 12 0ZM17.2685 9.88384L10.8069 16.3454C10.7212 16.4312 10.6194 16.4993 10.5073 16.5457C10.3953 16.5922 10.2752 16.6161 10.1538 16.6161C10.0325 16.6161 9.91243 16.5922 9.80037 16.5457C9.68831 16.4993 9.5865 16.4312 9.50077 16.3454L6.73154 13.5762C6.55834 13.4029 6.46103 13.168 6.46103 12.9231C6.46103 12.6781 6.55834 12.4432 6.73154 12.27C6.90475 12.0968 7.13967 11.9995 7.38462 11.9995C7.62957 11.9995 7.86449 12.0968 8.0377 12.27L10.1538 14.3873L15.9623 8.57769C16.0481 8.49193 16.1499 8.4239 16.2619 8.37748C16.374 8.33107 16.4941 8.30718 16.6154 8.30718C16.7367 8.30718 16.8568 8.33107 16.9688 8.37748C17.0809 8.4239 17.1827 8.49193 17.2685 8.57769C17.3542 8.66345 17.4223 8.76527 17.4687 8.87733C17.5151 8.98938 17.539 9.10948 17.539 9.23077C17.539 9.35205 17.5151 9.47216 17.4687 9.58421C17.4223 9.69627 17.3542 9.79808 17.2685 9.88384Z"
                    fill="var(--UH-Secondary-500, #00A2E1)"
                  />
                </svg>
                <svg
                  v-else-if="!shortlistSelectionMode"
                  xmlns="http://www.w3.org/2000/svg"
                  class="tw-h-[14px] tw-w-[14px] tw-text-white"
                  width="13"
                  height="9"
                  viewBox="0 0 13 9"
                  fill="none"
                >
                  <path
                    d="M12.0859 0.355469C12.4414 0.683594 12.4414 1.25781 12.0859 1.58594L5.08594 8.58594C4.75781 8.94141 4.18359 8.94141 3.85547 8.58594L0.355469 5.08594C0 4.75781 0 4.18359 0.355469 3.85547C0.683594 3.5 1.25781 3.5 1.58594 3.85547L4.48438 6.72656L10.8555 0.355469C11.1836 0 11.7578 0 12.0859 0.355469Z"
                    :fill="
                      localIsSelected && shortlistSelectionMode
                        ? '#00A2E1'
                        : 'white'
                    "
                  ></path>
                </svg>
              </span>
            </label>
          </div>

          <div
            v-if="swiperSlides.length > 1"
            class="min-h-165px property-listing-swiper swiper-container tw-group"
          >
            <!-- Right Arrow -->
            <div
              class="tw-absolute tw-right-[16px] tw-top-1/2 tw-z-10 tw--translate-y-1/2 tw-transform tw-opacity-0 tw-transition-opacity tw-duration-200 hover:tw-opacity-100 group-hover:tw-opacity-50 group-hover:hover:tw-opacity-100"
              @click="handleSwiperNavClick('next', $event)"
            >
              <img
                :src="cdnAsset('svg/caret-circle-right.svg')"
                class="tw-h-[40px] tw-w-[40px]"
                alt="Next"
              />
            </div>

            <!-- Left Arrow -->
            <div
              class="tw-absolute tw-left-[16px] tw-top-1/2 tw-z-10 tw--translate-y-1/2 tw-rotate-180 tw-transform tw-opacity-0 tw-transition-opacity tw-duration-200 hover:tw-opacity-100 group-hover:tw-opacity-50 group-hover:hover:tw-opacity-100"
              @click="handleSwiperNavClick('prev', $event)"
            >
              <img
                :src="cdnAsset('svg/caret-circle-right.svg')"
                class="tw-h-[40px] tw-w-[40px]"
                alt="Previous"
              />
            </div>

            <div
              :id="swiperId"
              ref="swiper"
              class="propertyListingSwiper swiper"
            >
              <!-- Additional required wrapper -->
              <div class="swiper-wrapper">
                <!-- Slides -->
                <div
                  v-for="(image, index) in swiperSlides"
                  :key="`slide-${index}`"
                  class="aspect-ratio-airbnb property-image-grey-background swiper-slide"
                >
                  <picture>
                    <source
                      media="(max-width: 430px)"
                      :srcset="
                        getResponsiveImageUrls(image)?.mobile ||
                        cdnAsset('svg/no-image.svg')
                      "
                    />
                    <source
                      media="(max-width: 576px)"
                      :srcset="
                        getResponsiveImageUrls(image)?.small ||
                        cdnAsset('svg/no-image.svg')
                      "
                    />
                    <source
                      media="(max-width: 768px)"
                      :srcset="
                        getResponsiveImageUrls(image)?.mobile ||
                        cdnAsset('svg/no-image.svg')
                      "
                    />
                    <source
                      media="(max-width: 1024px)"
                      :srcset="
                        getResponsiveImageUrls(image)?.tablet ||
                        cdnAsset('svg/no-image.svg')
                      "
                    />
                    <source
                      media="(max-width: 1199px)"
                      :srcset="
                        getResponsiveImageUrls(image)?.twoCol ||
                        cdnAsset('svg/no-image.svg')
                      "
                    />
                    <source
                      media="(min-width: 1200px)"
                      :srcset="
                        getResponsiveImageUrls(image)?.desktop ||
                        cdnAsset('svg/no-image.svg')
                      "
                    />
                    <img
                      :alt="property.shortDescription"
                      :src="
                        getResponsiveImageUrls(image)?.fallback ||
                        cdnAsset('svg/no-image.svg')
                      "
                      decoding="async"
                      loading="lazy"
                      :fetchpriority="index === 0 ? 'high' : 'auto'"
                      class="tw-block tw-h-full tw-w-full tw-object-cover tw-object-center tw-transition-transform tw-duration-100"
                    />
                  </picture>
                </div>
              </div>
              <!-- If we need pagination -->
              <div class="swiper-pagination"></div>
            </div>
          </div>
          <div v-else-if="property.mainImage" class="aspect-ratio-airbnb">
            <picture>
              <source
                media="(max-width: 430px)"
                :srcset="
                  getResponsiveImageUrls(propertyMainImage)?.mobile ||
                  cdnAsset('svg/no-image.svg')
                "
              />
              <source
                media="(max-width: 576px)"
                :srcset="
                  getResponsiveImageUrls(propertyMainImage)?.small ||
                  cdnAsset('svg/no-image.svg')
                "
              />
              <source
                media="(max-width: 768px)"
                :srcset="
                  getResponsiveImageUrls(propertyMainImage)?.mobile ||
                  cdnAsset('svg/no-image.svg')
                "
              />
              <source
                media="(max-width: 1024px)"
                :srcset="
                  getResponsiveImageUrls(propertyMainImage)?.tablet ||
                  cdnAsset('svg/no-image.svg')
                "
              />
              <source
                media="(max-width: 1199px)"
                :srcset="
                  getResponsiveImageUrls(propertyMainImage)?.twoCol ||
                  cdnAsset('svg/no-image.svg')
                "
              />
              <source
                media="(min-width: 1200px)"
                :srcset="
                  getResponsiveImageUrls(propertyMainImage)?.desktop ||
                  cdnAsset('svg/no-image.svg')
                "
              />
              <img
                :src="
                  getResponsiveImageUrls(propertyMainImage)?.fallback ||
                  property.mainImage
                "
                :loading="iteration <= 3 ? 'eager' : 'lazy'"
                decoding="async"
                :class="imgClasses"
                class="tw-h-full tw-w-full tw-object-cover"
                :alt="property.shortDescription"
              />
            </picture>
          </div>

          <Loading
            v-if="reloading"
            label=""
            wrapper-classes="bg-white-50 h-100 l-50 position-absolute transform-translate-minus-50 t-50 w-100 z-i-1"
          ></Loading>
        </div>

        <div
          v-if="swiperSlides.length >= 4"
          class="tw-flex tw-w-full tw-gap-[8px] tw-p-[16px_16px_0_16px] xs2:tw-hidden"
        >
          <div
            v-for="(image, index) in swiperSlides.slice(1, 5)"
            :key="`slide-${index}`"
            class="tw-aspect-square tw-flex-1 tw-overflow-hidden tw-rounded-[8px]"
          >
            <img
              :src="
                getResponsiveImageUrls(image)?.extraSmall ||
                cdnAsset('svg/no-image.svg')
              "
              alt=""
              class="tw-h-full tw-w-full tw-object-cover"
            />
          </div>
        </div>

        <div class="tw-relative tw-p-[16px]">
          <div
            class="tw-mb-[16px] tw-flex tw-flex-row tw-flex-wrap tw-items-start tw-gap-[8px] xs:tw-items-center"
          >
            <div
              class="tw-mb-0 tw-flex tw-items-center tw-space-x-1 tw-rounded-[16px] tw-border tw-border-uhblue-150 tw-px-[8px] tw-py-0 tw-text-[14px] tw-font-normal tw-leading-[27px] tw-text-uhblue-450 md:tw-pl-[2px]"
            >
              <div class="tw-w-[25px] md:tw-w-auto">
                <img
                  v-lazy="cdnAsset('svg/seal-check-icon.svg')"
                  alt="Seal Check Icon"
                  class="tw-h-[24px] tw-w-[24px]"
                  :src="cdnAsset('svg/no-image.svg')"
                />
              </div>

              <span>Bills Included</span>
            </div>

            <div
              v-if="isBTRProperty"
              class="tw-mb-0 tw-flex tw-items-center tw-space-x-1 tw-rounded-[16px] tw-border tw-border-uhblue-150 tw-px-[8px] tw-py-0 tw-text-[14px] tw-font-normal tw-leading-[27px] tw-text-uhblue-450 md:tw-pl-[6px]"
            >
              <div class="tw-w-[25px] md:tw-w-auto">
                <img
                  v-lazy="cdnAsset('svg/uh-halls-icon.svg')"
                  alt="Halls Icon"
                  class="tw-h-[24px] tw-w-[24px]"
                  :src="cdnAsset('svg/no-image.svg')"
                />
              </div>

              <span v-if="isBTRProperty">Private Halls</span>
              <span v-else>Halls</span>
            </div>
            <div
              v-else-if="isSpareRoomProperty"
              class="tw-mb-0 tw-flex tw-items-center tw-space-x-1 tw-rounded-[16px] tw-border tw-border-uhblue-150 tw-px-[8px] tw-py-0 tw-text-[14px] tw-font-normal tw-leading-[27px] tw-text-uhblue-450 md:tw-pl-[6px]"
            >
              <div class="tw-w-[15px] md:tw-w-auto">
                <img
                  v-lazy="cdnAsset('svg/phosphor/door-open.svg')"
                  alt="Spare Room Icon"
                  class="tw-h-[24px] tw-w-[24px]"
                  :src="cdnAsset('svg/no-image.svg')"
                />
              </div>
              <span>Spare rooms</span>
            </div>
            <div
              v-if="!isBTRProperty && !isSpareRoomProperty"
              class="tw-mb-0 tw-flex tw-items-center tw-space-x-1 tw-rounded-[16px] tw-border tw-border-uhblue-150 tw-px-[8px] tw-py-0 tw-text-[14px] tw-font-normal tw-leading-[27px] tw-text-uhblue-450 md:tw-pl-[8px]"
            >
              <div class="tw-w-[25px] md:tw-w-auto">
                <img
                  v-lazy="cdnAsset('svg/bathtub-icon.svg')"
                  alt="Bathtub Icon"
                  class="tw-h-6 tw-w-6"
                  :src="cdnAsset('svg/no-image.svg')"
                />
              </div>

              <span dusk="property-bathroom-count">
                {{ property.bathroomCount }}
                <span :class="{ 'tw-hidden': mapIsOpen }">bathrooms</span>
              </span>
            </div>

            <button
              v-if="
                !showHousemateVotePlaceholders &&
                !shortlistReadOnly &&
                isShortlistView &&
                !shortlistSelectionMode
              "
              type="button"
              class="text-body with-content-after-none tw-absolute tw-right-[16px] tw-top-[-28px] tw-z-10 tw-hidden tw-h-[50px] tw-w-[50px] tw-items-center tw-justify-center tw-rounded-full tw-border tw-border-gray-300 tw-bg-white tw-text-[#3B4143] hover:tw-border-uhblue-700 hover:tw-border-uhblue-700 hover:tw-text-uhblue-700 focus-visible:tw-border-uhblue-700 focus-visible:tw-text-uhblue-700 focus-visible:tw-ring-2 focus-visible:tw-ring-[#61B3E5] focus-visible:tw-ring-offset-2 xs2:tw-flex"
              role="button"
              aria-label="Remove from shortlist"
              @click.prevent="$emit('remove-from-shortlist', property.id)"
            >
              <Trash stroke-color="currentColor" />
            </button>

            <div
              v-else-if="
                !showHousemateVotePlaceholders &&
                !shortlistReadOnly &&
                !shortlistSelectionMode
              "
              class="align-items-center h-50px justify-content-center r-15px rounded-circle shortlist_expanded w-50px z-i-1 tw-absolute tw-right-[16px] tw-top-[-28px] tw-hidden xs2:tw-flex"
            >
              <span
                class="heart_new align-items-center border-none d-flex overflow-visible rounded-0 text-body with-content-after-none"
                role="button"
                :aria-label="
                  shortlistedLocal
                    ? 'Remove from shortlist'
                    : 'Add to shortlist'
                "
                :data-shortlisted="shortlistedLocal ? '1' : '0'"
                :data-uh="
                  shortlistedLocal ? 'shortlist-remove' : 'shortlist-add'
                "
                :data-add-shortlist="property.id"
                @click.prevent="toggleShortlist($event)"
              >
                <i
                  class="tw-before-h-24px tw-before-w-24px"
                  :class="{ activated: isShortlisted }"
                />
              </span>
            </div>
          </div>

          <div class="property_rooms_address position-relative tw-mb-[16px]">
            <h2
              class="tw-mb-0 tw-text-[20px] tw-font-semibold tw-leading-[30px] tw-text-primary-grey"
              dusk="property-bedroom-count"
              data-testid="search-results-property-tile-header"
            >
              {{ property.propertyName }}
            </h2>

            <div
              class="tw--ml-[4px] tw-mb-0 tw-flex tw-items-center tw-space-x-1 tw-text-[14px] tw-font-normal tw-leading-[21px] tw-text-darkergrey"
            >
              <img
                v-lazy="cdnAsset('svg/map-pin-grey.svg')"
                alt="Map Pin Icon"
                class="tw-h-[16px] tw-max-h-[16px] tw-w-[17px] tw-max-w-[17px] md:tw-h-[21px] md:tw-max-h-[21px] md:tw-w-[21px] md:tw-max-w-[21px]"
                :src="cdnAsset('svg/no-image.svg')"
              />

              <span>{{ property.addressShort }}</span>
            </div>
          </div>

          <div class="property_details">
            <h3
              v-if="isBTRProperty || isSpareRoomProperty"
              class="tw-font-inter tw-flex tw-items-baseline tw-gap-1 tw-text-[16px] tw-text-base tw-font-medium tw-leading-[24px] tw-text-darkergrey"
              :class="liveAt ? 'tw-mb-[13px]' : 'tw-mb-0'"
            >
              <span class="tw-flex tw-flex-wrap tw-space-x-1 sm:tw-pb-1">
                <!-- Price -->
                <span
                  dusk="property-price"
                  class="tw-font-bold tw-text-uhblue-450"
                >
                  £{{ property.cheapestRoomPrice }}
                </span>

                <!-- Paid per -->
                <span class="tw-tw-leading-[24px] tw-text-[14px]"
                  >per week</span
                >
              </span>
              <!-- BTR Room Count (optional A/B test pill) -->
              <span
                v-if="isBTRProperty && property.btrRoomsCount"
                class="tw-ml-auto tw-flex tw-flex-wrap tw-items-center tw-justify-center tw-gap-1 tw-rounded-[100px] tw-border tw-border-uhblue-150 tw-p-[8px] tw-text-[14px] tw-leading-[17px] tw-text-uhblue-450"
              >
                <span class="tw tw-font-bold">{{
                  property.btrRoomsCount
                }}</span>
                room {{ property.btrRoomsCount > 1 ? 'options' : 'option' }}
              </span>
              <span
                v-else-if="availableRoomsPillCount"
                class="tw-ml-auto tw-flex tw-flex-wrap tw-items-center tw-justify-center tw-gap-1 tw-rounded-[100px] tw-border tw-border-uhblue-150 tw-p-[8px] tw-text-[14px] tw-leading-[17px] tw-text-uhblue-450"
              >
                <span class="tw tw-font-bold">
                  {{ availableRoomsPillCount }}
                </span>
                {{ availableRoomsPillCount > 1 ? 'rooms' : 'room' }}
                available
              </span>
            </h3>

            <h3
              v-else
              class="tw-font-inter tw-flex tw-min-h-[35px] tw-items-center tw-text-[16px] tw-text-base tw-font-medium tw-leading-[24px] tw-text-darkergrey"
              :class="liveAt ? 'tw-mb-[13px]' : 'tw-mb-0'"
            >
              <!-- Price -->
              <span>
                <span
                  v-if="property.showFrom"
                  class="tw-tw-leading-[24px] tw-text-[14px]"
                  >From
                </span>

                <span
                  dusk="property-price"
                  class="tw-font-bold tw-text-uhblue-450"
                  >{{ price }}&nbsp;</span
                >
              </span>

              <!-- Paid per -->
              <span class="tw-tw-leading-[24px] tw-text-[14px]">
                per person per week</span
              >
            </h3>

            <div class="tw-flex tw-items-center">
              <div
                class="tw-flex tw-items-center tw-space-x-1 tw-text-[10px] tw-font-semibold tw-leading-[18px] tw-text-uhblue-450"
              >
                <img
                  v-lazy="cdnAsset('svg/info-blue.svg')"
                  alt="Info Icon"
                  class="tw-h-[16px] tw-w-[16px]"
                  :src="cdnAsset('svg/no-image.svg')"
                />

                <span v-if="liveAt"
                  >{{ liveAt }}, {{ availableFromLowercase }}</span
                >
                <span v-else>{{ property.availableFrom }}</span>
              </div>
            </div>

            <div v-if="admin" class="font-size-12px mt-10px property_admin">
              <strong>{{ adminFirstName }}</strong> -
              <a
                class="font-weight-bold"
                :href="property.adminPropertyEdit"
                rel="noopener noreferrer"
                target="_blank"
                title="Edit property"
                >edit this property</a
              >
              or
              <a
                class="font-weight-bold"
                :href="property.adminPropertyEdit + '#images'"
                rel="noopener noreferrer"
                target="_blank"
                title="Edit property images"
                >its images</a
              >
              or
              <a
                class="font-weight-bold"
                :href="property.adminLandlordEdit"
                rel="noopener noreferrer"
                target="_blank"
                title="Edit landlord"
                >edit {{ property.landlord.company }}</a
              >
              or
              <a
                class="font-weight-bold"
                :href="
                  property.routeIndex +
                  '?letting-agent=' +
                  property.landlord.obfuscatedId
                "
                rel="noopener noreferrer"
                target="_blank"
                title="Edit landlord"
                >view all {{ property.landlord.company }} properties</a
              >?
            </div>
          </div>

          <div
            v-if="showHousemateVoteActions && !useFullWidthHousemateVoteButtons"
            class="tw-mb-[8px] tw-mt-[16px] tw-flex tw-items-center tw-gap-[8px]"
          >
            <button
              type="button"
              class="tw-flex tw-h-[36px] tw-items-center tw-gap-[6px] tw-rounded-[999px] tw-border tw-px-[10px] tw-text-[13px] tw-font-semibold"
              :class="
                currentGroupVote === 'yes'
                  ? 'tw-border-[#497D00] tw-bg-[#F0FDF4] tw-text-[#497D00]'
                  : 'tw-border-[#D1D5DB] tw-bg-white tw-text-[#3B4143]'
              "
              :disabled="housemateVotingLocked"
              :aria-pressed="currentGroupVote === 'yes'"
              @click.stop.prevent="submitHousemateVote('yes')"
            >
              <ThumbsUp
                :stroke-color="
                  currentGroupVote === 'yes' ? '#497D00' : '#6B7280'
                "
              />
              <span>{{ Number(property.groupVoteYesCount ?? 0) }}</span>
            </button>

            <button
              type="button"
              class="tw-flex tw-h-[36px] tw-items-center tw-gap-[6px] tw-rounded-[999px] tw-border tw-px-[10px] tw-text-[13px] tw-font-semibold"
              :class="
                currentGroupVote === 'no'
                  ? 'tw-border-[#E7000B] tw-bg-[#FEF2F2] tw-text-[#E7000B]'
                  : 'tw-border-[#D1D5DB] tw-bg-white tw-text-[#3B4143]'
              "
              :disabled="housemateVotingLocked"
              :aria-pressed="currentGroupVote === 'no'"
              @click.stop.prevent="submitHousemateVote('no')"
            >
              <ThumbsDown
                :stroke-color="
                  currentGroupVote === 'no' ? '#E7000B' : '#6B7280'
                "
              />
              <span>{{ Number(property.groupVoteNoCount ?? 0) }}</span>
            </button>
          </div>

          <div
            v-if="useFullWidthHousemateVoteButtons"
            class="tw-mt-[16px]"
            @click.stop.prevent
          >
            <div class="tw-flex tw-w-full tw-items-center tw-gap-[12px]">
              <button
                type="button"
                class="tw-font-inter tw-flex tw-h-[40px] tw-flex-1 tw-items-center tw-justify-center tw-gap-[8px] tw-rounded-[25px] tw-border tw-border-[#D1D5DB] tw-bg-white tw-px-[11px] tw-py-[8px] tw-text-[14px] tw-font-normal tw-text-[#6B7280] disabled:tw-cursor-not-allowed disabled:tw-opacity-100"
                :class="[
                  currentGroupVote === 'yes'
                    ? 'tw-border-[#497D00] tw-bg-[#F3F8E8] tw-text-[#497D00]'
                    : '',
                  !housemateVotingLocked
                    ? 'focus-visible:tw-ring-2 focus-visible:tw-ring-[#61B3E5] focus-visible:tw-ring-offset-2'
                    : '',
                ]"
                :disabled="housemateVotingLocked"
                :aria-pressed="currentGroupVote === 'yes'"
                :aria-label="
                  showHousemateVoteActions
                    ? 'Thumbs up'
                    : 'Thumbs up (coming soon)'
                "
                @click.stop.prevent="submitHousemateVote('yes')"
              >
                <ThumbsUp
                  :stroke-color="
                    currentGroupVote === 'yes' ? '#497D00' : '#6B7280'
                  "
                  :size="22"
                />
                <span>{{ Number(property.groupVoteYesCount ?? 0) }}</span>
              </button>

              <button
                type="button"
                class="tw-font-inter tw-flex tw-h-[40px] tw-flex-1 tw-items-center tw-justify-center tw-gap-[8px] tw-rounded-[25px] tw-border tw-border-[#D1D5DB] tw-bg-white tw-px-[11px] tw-py-[8px] tw-text-[14px] tw-font-normal tw-text-[#6B7280] disabled:tw-cursor-not-allowed disabled:tw-opacity-100"
                :class="[
                  currentGroupVote === 'no'
                    ? 'tw-border-[#DC2626] tw-bg-[#FEF2F2] tw-text-[#DC2626]'
                    : '',
                  !housemateVotingLocked
                    ? 'focus-visible:tw-ring-2 focus-visible:tw-ring-[#61B3E5] focus-visible:tw-ring-offset-2'
                    : '',
                ]"
                :disabled="housemateVotingLocked"
                :aria-pressed="currentGroupVote === 'no'"
                :aria-label="
                  showHousemateVoteActions
                    ? 'Thumbs down'
                    : 'Thumbs down (coming soon)'
                "
                @click.stop.prevent="submitHousemateVote('no')"
              >
                <ThumbsDown
                  :stroke-color="
                    currentGroupVote === 'no' ? '#DC2626' : '#6B7280'
                  "
                  :size="22"
                />
                <span>{{ Number(property.groupVoteNoCount ?? 0) }}</span>
              </button>
            </div>
          </div>

          <div
            v-if="!useFullWidthHousemateVoteButtons && !shortlistReadOnly"
            class="tw-flex tw-items-center tw-justify-between tw-gap-[12px] tw-pt-[16px] xs2:tw-hidden"
          >
            <button
              v-if="
                !useFullWidthHousemateVoteButtons &&
                isShortlistView &&
                !shortlistSelectionMode
              "
              type="button"
              class="text-body with-content-after-none tw-flex tw-h-[50px] tw-w-[50px] tw-items-center tw-justify-center tw-rounded-full tw-border tw-border-gray-300 tw-bg-white hover:tw-border-uhblue-700 hover:tw-border-uhblue-700 hover:tw-text-uhblue-700 focus-visible:tw-border-uhblue-700 focus-visible:tw-text-uhblue-700 focus-visible:tw-ring-2 focus-visible:tw-ring-[#61B3E5] focus-visible:tw-ring-offset-2"
              role="button"
              aria-label="Remove from shortlist"
              @click.prevent="$emit('remove-from-shortlist', property.id)"
            >
              <Trash stroke-color="currentColor" />
            </button>

            <button
              v-else-if="
                !useFullWidthHousemateVoteButtons && !shortlistSelectionMode
              "
              type="button"
              class="heart_mobile shortlist_expanded focus-visible:outline-none tw-flex tw-h-[50px] tw-w-[50px] tw-items-center tw-justify-center tw-rounded-full tw-border tw-border-gray-300 tw-bg-white hover:tw-border-uhblue-700 focus-visible:tw-border-uhblue-700 focus-visible:tw-ring-2 focus-visible:tw-ring-[#61B3E5] focus-visible:tw-ring-offset-2"
              :data-add-shortlist="property.id"
              :aria-label="
                shortlistedLocal ? 'Remove from shortlist' : 'Add to shortlist'
              "
              :data-shortlisted="shortlistedLocal ? '1' : '0'"
              :data-uh="shortlistedLocal ? 'shortlist-remove' : 'shortlist-add'"
              @click.prevent="toggleShortlist($event)"
            >
              <img
                :src="
                  isShortlisted
                    ? cdnAsset('svg/heart-icon-red.svg')
                    : cdnAsset('svg/heart-icon-dark-grey.svg')
                "
                alt=""
                aria-hidden="true"
              />

              <span class="sr-only">{{
                shortlistedLocal ? 'Remove from shortlist' : 'Add to shortlist'
              }}</span>
            </button>

            <button
              class="focus-visible:outline-none tw-flex tw-h-[50px] tw-w-[50px] tw-items-center tw-justify-center tw-rounded-full tw-border tw-border-gray-300 tw-bg-white hover:tw-border-uhblue-700 focus-visible:tw-border-uhblue-700 focus-visible:tw-ring-2 focus-visible:tw-ring-[#61B3E5] focus-visible:tw-ring-offset-2"
              aria-label="Share this property"
              type="button"
              @click.stop.prevent="shareProperty"
            >
              <img
                :src="cdnAsset('svg/share-network-icon.svg')"
                alt=""
                aria-hidden="true"
              />

              <span class="tw-sr-only">Share this property</span>
            </button>

            <a
              :href="property.path"
              class="focus-visible:outline-none tw-flex tw-h-[50px] tw-flex-[1_0_0] tw-items-center tw-justify-center tw-gap-2 tw-rounded-[30px] tw-bg-button-grad tw-px-[16px] tw-py-[8px] tw-text-[14px] tw-font-[600] tw-text-white focus-visible:tw-ring-2 focus-visible:tw-ring-[#61B3E5] focus-visible:tw-ring-offset-2 xs:tw-px-[24px]"
            >
              View property
              <img
                :src="cdnAsset('svg/white-arrow-icon.svg')"
                alt=""
                aria-hidden="true"
              />
            </a>
          </div>
        </div>
      </a>
    </div>

    <SaveToShortlistModal
      v-if="enableHousemateGroups && showHousemateGroupTab && isLoggedInStudent"
      :open="showSaveToShortlistModal"
      :property-id="property.id"
      :is-logged-in-student="isLoggedInStudent"
      @close="showSaveToShortlistModal = false"
      @saved="handleSaveDestination"
    />
  </div>
</template>

<script>
import { ADVERT_TYPE_BTR, ADVERT_TYPE_SPARE_ROOM } from '@js/constants';
import {
  hasLivingContext,
  VARIANT_REMAINING_ROOMS,
} from '@components/Property/livingContext.ts';
import Swiper, { Pagination } from 'swiper';
import { usePropertiesStore } from '@js/stores/properties';
import dayjs from 'dayjs';
import Loading from './Loading';
import ListingIncentive2024 from './Property/ListingIncentive2024';
import Trash from '@components/Student/SVG/Trash.vue';
import ThumbsUp from '@components/Student/SVG/ThumbsUp.vue';
import ThumbsDown from '@components/Student/SVG/ThumbsDown.vue';
import { observeShortlistAttribute } from './Student/helpers/shortlistObserver';
import { useStudentStore } from '@js/stores/student/student';
import SaveToShortlistModal from '@components/Student/Modal/SaveToShortlistModal.vue';
import {
  showShortlistAddedNotification,
  showShortlistRemovedNotification,
} from '@components/Property/shortlistNotification';

import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/lazy';

const createGuestStudentStore = () => ({
  housemateGroupShortlistedByPropertyId: {},
  isPersonallyShortlisted: () => false,
  async ensureHousemateGroupsShortlistContextLoaded() {},
  async toggleHousemateGroupsShortlist() {},
});

export default {
  name: 'PropertyListingFeatured',
  components: {
    Loading,
    ListingIncentive2024,
    Trash,
    SaveToShortlistModal,
    ThumbsUp,
    ThumbsDown,
  },
  inject: {
    shortlistNotificationsEnabled: {
      default: false,
    },
  },
  props: {
    abbreviate: {
      default: true,
      type: Boolean,
    },
    admin: {
      default: false,
      type: Boolean,
    },
    mapIsOpen: {
      default: false,
      type: Boolean,
    },
    isLoggedInStudent: {
      default: false,
      type: Boolean,
    },
    adminFirstName: {
      default: null,
      type: String,
    },
    bottomOfThePage: {
      default: window.innerHeight,
      type: Number,
    },
    classList: {
      default: 'h-100 m-0',
      type: String,
    },
    currentScroll: {
      default: 0,
      type: Number,
    },
    hideButtons: {
      default: true,
      type: Boolean,
    },
    imgClasses: {
      default: 'max-w-100',
      type: String,
    },
    iteration: {
      default: 0,
      type: Number,
    },
    listing: {
      default: 'listing',
      type: String,
    },
    paginate: {
      default: 18,
      type: Number,
    },
    property: {
      default: function () {
        return {};
      },
      required: true,
      type: Object,
    },
    reloading: {
      default: false,
      type: Boolean,
    },
    screenKey: {
      default: null,
      type: String,
    },
    streamlined: {
      default: false,
      type: Boolean,
    },
    swiperClasses: {
      default: null,
      type: String,
    },
    windowHeight: {
      default: window.innerHeight,
      type: Number,
    },
    isShortlistView: {
      default: false,
      type: Boolean,
    },
    shortlistReadOnly: {
      default: false,
      type: Boolean,
    },
    shortlistActive: {
      default: false,
      type: Boolean,
    },
    enableShortlistInSearch: {
      default: false,
      type: Boolean,
    },
    enableHousemateGroups: {
      default: null,
      type: Boolean,
    },
    showHousemateGroupTab: {
      default: true,
      type: Boolean,
    },
    housemateGroupActive: {
      default: false,
      type: Boolean,
    },
    housemateGroupId: {
      default: null,
      type: [Number, String],
    },
    showHousemateVotePlaceholders: {
      default: false,
      type: Boolean,
    },
    isSelected: {
      type: Boolean,
      default: false,
    },
    shortlistSelectionMode: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      studentStore: this.isLoggedInStudent
        ? useStudentStore()
        : createGuestStudentStore(),
      shortlistStateStore: useStudentStore(),
      mountDone: false,
      swiper: null,
      swiperId: null,
      swiperSlides: this.property.images,
      shortlistedLocal: this.shortlistActive || this.property.shortlisted,
      ADVERT_TYPE_BTR,
      shortlistedHousemateGroupId: null,
      localIsSelected: this.isSelected,
      showSaveToShortlistModal: false,
    };
  },
  computed: {
    groupLastEnquiredAt() {
      return (
        this.property?.housemateGroupLastEnquiredAt ??
        this.property?.housemate_group_last_enquired_at ??
        null
      );
    },
    availableFromLowercase() {
      const str = this.property.availableFrom;
      if (!str) return str; // Check for empty string or null
      return str.charAt(0).toLowerCase() + str.slice(1);
    },
    // Generate responsive image URLs using Cloudflare CDN width parameters
    getResponsiveImageUrls() {
      return (image) => {
        const baseUrl = image.fileURLTablet || image.mainImage;
        if (!baseUrl) return null;

        // Replace width parameter in Cloudflare CDN URL
        const extraSmallUrl = baseUrl
          .replace(/width=\d+/, 'width=120')
          .replace(/quality=75/, 'quality=90');
        const mobileUrl = baseUrl
          .replace(/width=\d+/, 'width=390')
          .replace(/quality=75/, 'quality=90');
        const smallUrl = baseUrl
          .replace(/width=\d+/, 'width=535')
          .replace(/quality=75/, 'quality=90');
        const tabletUrl = baseUrl
          .replace(/width=\d+/, 'width=468')
          .replace(/quality=75/, 'quality=90');
        const desktopUrl = baseUrl
          .replace(/width=\d+/, 'width=400')
          .replace(/quality=75/, 'quality=90');
        const twoColUrl = baseUrl
          .replace(/width=\d+/, 'width=548')
          .replace(/quality=75/, 'quality=90');

        return {
          mobile: mobileUrl,
          extraSmall: extraSmallUrl,
          small: smallUrl,
          tablet: tabletUrl,
          desktop: desktopUrl,
          twoCol: twoColUrl,
          fallback: this.propertyMainImage?.fileURLTablet ?? null,
        };
      };
    },
    isShortlisted() {
      return this.shortlistedLocal;
    },
    liveAt() {
      const liveAtDate = dayjs(this.property.liveAt);
      const now = dayjs();

      const daysDiff = now.diff(liveAtDate, 'day');
      const weeksDiff = now.diff(liveAtDate, 'week');
      const monthsDiff = now.diff(liveAtDate, 'month');
      const yearsDiff = now.diff(liveAtDate, 'year');

      // Hide "Added X ago" if older than 3 weeks (21 days)
      if (daysDiff > 21) {
        return null;
      }

      if (daysDiff < 1) {
        return `Added today`;
      }
      if (daysDiff < 2) {
        return `Added yesterday`;
      }
      if (daysDiff < 7) {
        return `Added ${daysDiff} days ago`;
      } else if (weeksDiff < 2) {
        return `Added ${weeksDiff} week ago`;
      } else if (weeksDiff < 5) {
        return `Added ${weeksDiff} weeks ago`;
      } else if (monthsDiff < 2) {
        return `Added ${monthsDiff} month ago`;
      } else if (monthsDiff < 12) {
        return `Added ${monthsDiff} months ago`;
      } else {
        return `Added ${yearsDiff} years ago`;
      }
    },
    bottom() {
      return this.mountDone && this.$refs.propertyListing
        ? this.$refs.propertyListing.getBoundingClientRect().bottom +
            this.browserTop
        : false;
    },
    browserTop() {
      return window.scrollY;
    },
    showSkeleton() {
      return false;
    },
    showLoader() {
      return this.reloading;
    },
    isBTRProperty() {
      return this.property.advertType === ADVERT_TYPE_BTR;
    },
    isSpareRoomProperty() {
      return this.property.advertType === ADVERT_TYPE_SPARE_ROOM;
    },
    availableRoomsPillCount() {
      // A blended result reports its own availability, so every spare room advert and any
      // partially occupied house gets the pill a spare room advert gets today
      if (hasLivingContext(this.property)) {
        return this.property.variantKind === VARIANT_REMAINING_ROOMS
          ? Number(this.property.roomsAvailableCount) || 0
          : 0;
      }

      return this.isSpareRoomProperty
        ? Number(this.property.spareRoomsAvailableCount) || 0
        : 0;
    },
    hasPriceRange() {
      return (
        this.property.cheapestRoomPrice !== this.property.mostExpensiveRoomPrice
      );
    },
    price() {
      const { price, cheapestRoomPrice, mostExpensiveRoomPrice } =
        this.property;

      if (this.isBTRProperty && this.hasPriceRange) {
        return `£${cheapestRoomPrice} - £${mostExpensiveRoomPrice}`;
      }

      return `£${price}`;
    },
    top() {
      return this.mountDone && this.$refs.propertyListing
        ? this.$refs.propertyListing.getBoundingClientRect().top +
            this.browserTop
        : false;
    },
    showIncentives() {
      return usePropertiesStore().showIncentives;
    },
    propertyMainImage() {
      return this.property?.mainImage
        ? {
            fileURLTablet: this.property.mainImage,
          }
        : null;
    },
    showHousemateVoteActions() {
      return Boolean(
        this.housemateGroupActive &&
          this.housemateGroupId &&
          !this.isShortlistView
      );
    },
    housemateVotingLocked() {
      return (
        !this.showHousemateVoteActions || Boolean(this.groupLastEnquiredAt)
      );
    },
    currentGroupVote() {
      return typeof this.property?.groupVote === 'string'
        ? this.property.groupVote.toLowerCase()
        : null;
    },
    useFullWidthHousemateVoteButtons() {
      return Boolean(
        this.showHousemateVotePlaceholders || this.housemateGroupActive
      );
    },
  },
  watch: {
    property: {
      handler(newVal) {
        if (
          this.enableHousemateGroups &&
          this.showHousemateGroupTab &&
          this.isLoggedInStudent
        ) {
          const propertyId = newVal?.id;
          const groupId = propertyId
            ? this.studentStore.housemateGroupShortlistedByPropertyId?.[
                String(propertyId)
              ]
            : null;

          if (groupId) {
            this.shortlistedLocal = true;
            this.shortlistedHousemateGroupId = Number(groupId);
          } else if (propertyId) {
            this.shortlistedHousemateGroupId = null;
            this.shortlistedLocal =
              this.studentStore.isPersonallyShortlisted?.(propertyId);
          } else {
            this.shortlistedLocal = Boolean(newVal.shortlisted);
          }
        } else {
          this.shortlistedLocal =
            this.shortlistActive || Boolean(newVal.shortlisted);
        }
        this.swiperSlides = newVal.images;
      },
      deep: true,
    },
    reloading: function (boolean) {
      if (boolean) {
        // Pop off all the current slides
        if (!this.isShortlistView) {
          this.swiperSlides = [];
        }

        this.mountDone = false;
      } else {
        // Put the new images into the slider
        this.swiperSlides = this.property.images;
        this.swiperReload();
        this.mountDone = true;
      }
    },
    screenKey: function () {
      // Map opening and closing, screen being moved etc
    },
    isSelected(newVal) {
      this.localIsSelected = newVal;
    },
  },

  mounted() {
    this.mountDone = true;
    this.swiperId = this.makeId(10);
    this.setupSwiper();

    if (
      this.enableHousemateGroups &&
      this.showHousemateGroupTab &&
      this.isLoggedInStudent
    ) {
      const heartElement = this.$el.querySelector('.heart_new');
      this.shortlistObserver = observeShortlistAttribute(heartElement);

      const heartElementMobile = this.$el.querySelector('.heart_mobile');
      this.shortlistObserverMobile =
        observeShortlistAttribute(heartElementMobile);

      (async () => {
        await this.studentStore
          .ensureHousemateGroupsShortlistContextLoaded?.()
          .catch(() => null);

        const propertyId = this.property?.id;
        if (!propertyId) {
          return;
        }

        const groupId =
          this.studentStore.housemateGroupShortlistedByPropertyId?.[
            String(propertyId)
          ];

        if (groupId) {
          this.shortlistedLocal = true;
          this.shortlistedHousemateGroupId = Number(groupId);
          return;
        }

        this.shortlistedHousemateGroupId = null;
        this.shortlistedLocal =
          this.studentStore.isPersonallyShortlisted?.(propertyId) ||
          Boolean(this.property?.shortlisted);
      })();
    }
  },
  updated() {
    const swiperElement = this.$refs.swiper;

    if (this.swiper?.el === swiperElement) {
      return;
    }

    const activeIndex = this.swiper?.realIndex || 0;
    this.swiper?.destroy();
    this.swiper = null;

    if (!swiperElement) {
      return;
    }

    this.setupSwiper();

    if (activeIndex > 0) {
      this.swiper?.slideTo(activeIndex, 0, false);
    }
  },

  methods: {
    async toggleShortlist(event) {
      const propertyId = this.property?.id;
      if (!propertyId) {
        return;
      }

      if (this.enableShortlistInSearch) {
        event?.stopPropagation?.();
        event?.stopImmediatePropagation?.();
      }

      if (
        this.enableShortlistInSearch &&
        this.shortlistActive &&
        !this.shortlistReadOnly &&
        this.shortlistedLocal
      ) {
        this.$emit('remove-from-shortlist', propertyId);
        return;
      }

      if (
        !this.enableHousemateGroups ||
        !this.showHousemateGroupTab ||
        !this.isLoggedInStudent
      ) {
        const currentlyShortlisted = this.shortlistedLocal;

        try {
          if (currentlyShortlisted) {
            await this.shortlistStateStore.removeFromShortlist(propertyId);
            this.shortlistedLocal = false;
            if (this.shortlistNotificationsEnabled) {
              this.showPersonalShortlistRemovedFeedback();
            }
            return;
          }

          const response = await this.shortlistStateStore.postAddToShortlist(
            propertyId,
            this.property
          );

          if (!response?.data?.success) {
            this.shortlistedLocal = currentlyShortlisted;
            return;
          }

          this.shortlistedLocal = true;
          if (this.shortlistNotificationsEnabled) {
            showShortlistAddedNotification(this.property);
          }
        } catch {
          this.shortlistedLocal = currentlyShortlisted;
        }

        return;
      }

      event?.stopPropagation?.();
      event?.stopImmediatePropagation?.();

      const result = await this.studentStore.toggleHousemateGroupsShortlist?.({
        propertyId,
        property: this.property,
        currentHousemateGroupId: this.shortlistedHousemateGroupId,
        isUiShortlisted: this.shortlistedLocal,
      });

      if (result?.action === 'needs-modal') {
        this.showSaveToShortlistModal = true;
        return;
      }

      if (result?.action === 'added-personal') {
        this.shortlistedLocal = true;
        this.shortlistedHousemateGroupId = null;
        if (this.shortlistNotificationsEnabled) {
          showShortlistAddedNotification(this.property);
        }
        return;
      }

      if (result?.action === 'added-group') {
        this.shortlistedLocal = true;
        this.shortlistedHousemateGroupId = result?.groupId ?? null;
        return;
      }

      if (
        result?.action === 'removed-personal' ||
        result?.action === 'removed-group'
      ) {
        this.shortlistedLocal = false;
        this.shortlistedHousemateGroupId = null;
        if (
          result?.action === 'removed-personal' &&
          this.shortlistNotificationsEnabled
        ) {
          this.showPersonalShortlistRemovedFeedback();
        }
      }
    },
    showPersonalShortlistRemovedFeedback() {
      if (!this.shortlistNotificationsEnabled) return;

      showShortlistRemovedNotification(this.property, async () => {
        if (this.shortlistedLocal) return true;

        const propertyId = String(this.property?.id || '').trim();
        if (!propertyId) return false;

        const response = await this.shortlistStateStore.postAddToShortlist(
          propertyId,
          this.property
        );
        if (!response?.data?.success) return false;

        this.shortlistedLocal = true;
        this.shortlistedHousemateGroupId = null;
        return true;
      });
    },
    handleSaveDestination(payload = {}) {
      this.shortlistedLocal = true;

      if (payload?.destination === 'group') {
        this.shortlistedHousemateGroupId = payload?.groupId ?? null;
      } else {
        this.shortlistedHousemateGroupId = null;
        if (this.shortlistNotificationsEnabled) {
          showShortlistAddedNotification(this.property);
        }
      }
    },
    submitHousemateVote(vote) {
      if (this.housemateVotingLocked || !this.showHousemateVoteActions) {
        return;
      }

      if (!['yes', 'no'].includes(vote)) {
        return;
      }

      this.$emit('housemate-group-vote', {
        propertyId: this.property.id,
        vote,
      });
    },
    makeId: function (length) {
      let result = '',
        characters =
          'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789',
        charactersLength = characters.length;
      for (let i = 0; i < length; i++) {
        result += characters.charAt(
          Math.floor(Math.random() * charactersLength)
        );
      }
      return result;
    },
    setupSwiper: function () {
      this.swiper = new Swiper(this.$refs.swiper, {
        // Optional parameters
        loop: this.loop,
        // Disable preloading of all images
        preloadImages: false,

        // configure Swiper to use modules
        modules: [Pagination],

        // If we need pagination
        pagination: {
          clickable: true,
          el: '.swiper-pagination',
          dynamicBullets: true,
          dynamicMainBullets: 3,
          type: 'bullets',
        },
      });

      this.swiper.on('slideChange', () => {
        this.swiper.update();
      });
    },
    swiperReload: function () {
      // Once all the images have been reloaded, reinitialise the swiper
      this.$nextTick(() => {
        this.setupSwiper();
      });
    },
    screenResized: function () {
      // Once all the images have been reloaded, reinitialise the swiper
      this.$nextTick(() => {
        this.setupSwiper();
      });
    },
    UCFirst(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    redirectToPropertyPage() {
      //I think isn't getting hit as its called in an @click next to a href
      if (typeof ga === 'undefined') {
        window.location = this.property.path;
        return;
      }

      let clickEventData = {
        incentive: false,
      };
      if (this.property.incentive) {
        clickEventData.incentive = {
          type: this.property.incentive.type,
          message: this.property.incentive.message,
          visible: this.showIncentives,
        };
      }

      ga('send', 'property_card_click', 'Properties', 'Card', clickEventData);
      window.location = this.property.path;
    },
    handleSwiperNavClick(direction) {
      event.preventDefault();
      event.stopPropagation();

      if (this.swiper) {
        direction === 'next'
          ? this.swiper.slideNext()
          : this.swiper.slidePrev();
      }
    },
    shareProperty() {
      const shareData = {
        title: this.property.title || 'Check out this property',
        text: 'Found this property you might like:',
        url: `https://unihomes.co.uk/${this.property.path}`,
      };

      if (navigator.share) {
        navigator.share(shareData);
      }
    },
    onSelectChange(event) {
      const checked = event.target.checked;

      this.localIsSelected = checked;

      this.$emit('selection-change', {
        id: this.property.id,
        checked,
      });
    },
  },
  beforeDestroy() {
    if (this.shortlistObserver) {
      this.shortlistObserver.disconnect();
    }
    if (this.shortlistObserverMobile) {
      this.shortlistObserverMobile.disconnect();
    }
  },
};
</script>
<style lang="scss">
.propertyListingSwiper {
  .swiper-lazy-preloader {
    border-right-color: #00a2e1 !important;
    border-bottom-color: #00a2e1 !important;
    border-left-color: #00a2e1 !important;
  }

  .swiper-pagination {
    top: auto;
    transform: translate3d(0, 0, 0);

    .swiper-pagination-bullet {
      transform: scale(1);
      border: none;
      background: white;
      height: 6px;
      margin: 0 3px;
      opacity: 0.5 !important;
      transition-property: left;
      width: 6px;

      &.swiper-pagination-bullet-active {
        opacity: 1 !important;
        background: white !important;
        height: 6px !important;
        width: 6px !important;
      }
    }
  }
}
</style>
